import { render, staticRenderFns } from "./RegistrationSteps.vue?vue&type=template&id=be264670&scoped=true&"
import script from "./RegistrationSteps.vue?vue&type=script&lang=js&"
export * from "./RegistrationSteps.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationSteps.vue?vue&type=style&index=0&id=be264670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be264670",
  null
  
)

export default component.exports